import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Card,
  Divider,
  Text,
  tokens,
} from "@fluentui/react-components";
import { SparkleRegular } from "@fluentui/react-icons";
import { formatTextToHTML } from "../utils/format";
import LoadingDots from "./LoadingDots";

export default function AnalysisCard({
  summaryText,
  nerText,
  isAnalyzing,
  isError,
  isOpen,
  onToggle,
  t,
}) {
  const openItems = isOpen ? ["analysis"] : [];

  const handleToggle = (_event, data) => {
    onToggle?.(data.openItems.includes("analysis"));
  };

  return (
    <Card
      style={{
        backgroundColor: "var(--aco-accent-bg)",
        border: "1px solid var(--aco-accent-border)",
        padding: "0",
        overflow: "hidden",
      }}
    >
      <Accordion
        collapsible
        openItems={openItems}
        onToggle={handleToggle}
      >
        <AccordionItem value="analysis">
          <AccordionHeader
            expandIconPosition="start"
            style={{ padding: "2px 6px" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <SparkleRegular style={{ color: "var(--aco-accent)", fontSize: "16px" }} />
              <Text
                weight="semibold"
                size={200}
                style={{
                  color: tokens.colorNeutralForeground2,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {t("analysis.title")}
              </Text>
            </div>
          </AccordionHeader>
          <AccordionPanel>
            <div
              style={{
                padding: "0 4px 6px 4px",
                fontSize: "13px",
                lineHeight: "1.35",
                color: tokens.colorNeutralForeground1,
                maxHeight: "320px",
                overflowY: "auto",
              }}
            >
              {isAnalyzing && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingBottom: "8px" }}>
                  <LoadingDots size="small" />
                  <Text size={200} style={{ color: tokens.colorNeutralForeground2, fontStyle: "italic" }}>
                    {t("status.analyzing")}
                  </Text>
                </div>
              )}

              {isError && (
                <Text style={{ color: tokens.colorPaletteRedForeground1 }}>{t("result.error")}</Text>
              )}

              {!isError && (summaryText || nerText) && (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <div>
                    <Text
                      weight="semibold"
                      style={{
                        color: "var(--aco-accent)",
                        fontSize: "12px",
                        display: "block",
                        marginBottom: "2px",
                      }}
                    >
                      {t("analysis.summary")}
                    </Text>
                    <div dangerouslySetInnerHTML={{ __html: formatTextToHTML(summaryText || "") }} />
                  </div>

                  <Divider style={{ opacity: 0.5, margin: "2px 0" }} />

                  <div>
                    <Text
                      weight="semibold"
                      style={{
                        color: "var(--aco-accent)",
                        fontSize: "12px",
                        display: "block",
                        marginBottom: "2px",
                      }}
                    >
                      {t("analysis.keypoints")}
                    </Text>
                    <div dangerouslySetInnerHTML={{ __html: formatTextToHTML(nerText || "") }} />
                  </div>
                </div>
              )}

              {!isAnalyzing && !isError && !summaryText && !nerText && (
                <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>
                  {t("ner.none")}
                </Text>
              )}
            </div>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Card>
  );
}
